var supportsVoiceOver = function supportsVoiceOver() {
  return (/Mac OS X/.test(navigator.userAgent)
  );
};

export default supportsVoiceOver;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/dropdown-menu/dist/esm/util/supportsVoiceover.js
// module id = 300
// module chunks = 0